module.exports = __webpack_public_path__ + "static/img/xubin.fbf0258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/xubin.png
// module id = KPcW
// module chunks = 0